import {getRequest, postRequest} from "../../src/api/index.js";
import {REGISTER, REGISTER_ERROR} from "../../src/actions/types.js";
export const keyDateByOrbit = async (data, cb) => async (
    dispatch
) => {
    try {
        const res = await getRequest(`/user/retrieveKeyDateByOrbit/${data.orbitId}`, "user");

        if (res.status !== 400)
            cb(res.data);
        else
            dispatch({
                type: REGISTER_ERROR,
                payload: res.data.errors[0]
            });
    } catch (err) {
        if (err.response) {
            // There is an error response from the server
            // You can anticipate error.response.data here
            if (err.response.data && err.response.data.errors[0]) {
                dispatch({
                    type: REGISTER_ERROR,
                    payload: err.response.data.errors[0]
                });
            } else {
                const error = err.response.data;
                dispatch({
                    type: REGISTER_ERROR,
                    payload: err.message
                });
            }
        } else if (err.request) {
            // The request was made but no response was received
            // Error details are stored in error.reqeust
            dispatch({
                type: REGISTER_ERROR,
                payload: err.request
            });
        } else if (err) {
            dispatch({
                type: REGISTER_ERROR,
                payload: err.message
            });
        } else {
            // Some other errors
            dispatch({
                type: REGISTER_ERROR,
                payload: "Something went wrong."
            });
        }
    }
};
